import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierTransactionSyncStatus } from "../../types/Quote";

export const getSyncDossierTransactionsStatus = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    isQueryEnabled,
    defaultOnMutateSuccess,
    defaultOnMutateError,
    defaultOnMutateSettled,
  } = useAPQuery();
  const queryKey = ["syncDossierTransactionsStatus", dossierId];
  const invalidateList = [
    ["dossier", dossierId],
    ["dossierTransactionComparison", dossierId],
  ];
  return useQuery({
    queryKey,
    queryFn: (): Promise<DossierTransactionSyncStatus> => {
      return fetchWithAuth<DossierTransactionSyncStatus>(
        "getSyncDossierTransactionsStatus",
        dossierId
      );
    },
    enabled: isQueryEnabled(options),
    onSettled: (data) => {
      if (data === "SYNCING") {
        setTimeout(() => {
          defaultOnMutateSettled([queryKey]);
        }, 5000);
      } else if (
        data === "SUCCESS" &&
        options.mutationOptions?.successAlertMessage
      ) {
        const success = defaultOnMutateSuccess(options);
        success && success();
        defaultOnMutateSettled(invalidateList);
      } else if (options.mutationOptions?.errorAlertMessage) {
        const errorMessage = `${options.mutationOptions.errorAlertMessage}, Reason: ${data}`;

        const onError = defaultOnMutateError({
          ...options,
          mutationOptions: {
            ...options.mutationOptions,
            errorAlertMessage: errorMessage,
          },
        });

        onError();
      }
    },
  });
};
